<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Enviar documento</div>
            </div>
            <div class="card-body">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="arquivo"><span class="required">*</span> Arquivo PDF:</label>
                  <input type="file" accept="application/pdf,.pdf" class="form-control" id="arquivo" @change="selecionarArquivo" />
                </div>
                <div class="form-group col-md-6">
                  <label for="nome">Nome do documento:</label>
                  <input type="text" id="nome" class="form-control" v-model="nome" placeholder="Usa o nome do arquivo se ficar em branco" />
                </div>
              </div>

              <span class="required_fields">
                <span class="required">*</span>
                <strong>Campos obrigatórios</strong>
              </span>
              <div class="block text-right">
                <router-link to="/documentos" class="btn btn-back">
                  <i class="fa fa-arrow-left"></i> Voltar
                </router-link>
                <button type="button" class="btn btn-add ml-1" :disabled="enviando" @click="enviar">
                  {{ enviando ? "Enviando..." : "Enviar" }}
                  <i class="fa fa-upload"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      arquivo: null,
      nome: "",
      enviando: false,
    };
  },
  methods: {
    selecionarArquivo(evento) {
      this.arquivo = evento.target.files[0] || null;
    },
    enviar() {
      const self = this;

      if (!self.arquivo) {
        self.$message(null, "Selecione o arquivo PDF.", "error");
        return;
      }

      let fd = new FormData();
      fd.append("arquivo", self.arquivo);
      fd.append("nome", self.nome || "");

      self.enviando = true;
      axios
        .post(self.$store.state.api + "documentos", fd)
        .then((response) => {
          self.$message("Sucesso", "Documento enviado.", "success");
          self.$router.push("/documentos/view/" + response.data.id);
        })
        .catch((error) => {
          self.$message(null, error.response ? error.response.data : error, "error");
        })
        .finally(() => {
          self.enviando = false;
        });
    },
  },
};
</script>
